// src/components/songEdit/forms/TuneForm.tsx
import React, { useState, useEffect } from 'react';
import { Tune } from '../types/tuneTypes';

interface TuneFormProps {
  initialTune?: Tune;
  onSubmit: (tune: Tune) => void;
  onClose: () => void;
}

export const TuneForm: React.FC<TuneFormProps> = ({
  initialTune,
  onSubmit,
  onClose
}) => {
  const [formData, setFormData] = useState<Tune>({
    tune_name: '',
    meter_id: undefined,
    is_preferred: false,
    ...initialTune
  });

  // Keep local state in sync with prop changes
  useEffect(() => {
    if (initialTune) {
      setFormData({
        ...initialTune,
        meter_id: initialTune.meter_id,
        is_preferred: initialTune.is_preferred || false
      });
    }
  }, [initialTune]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked 
              : type === 'number' ? (value ? parseInt(value) : undefined)
              : value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('[TuneForm] Submitting tune:', formData);
    onSubmit(formData);
  };

  return (
    <div className="border rounded p-4 mt-2 bg-gray-50">
      <form onSubmit={handleSubmit}>
        <h4 className="mb-3">
          {initialTune?.tune_id ? 'Edit Tune' : 'Add New Tune'}
        </h4>
        
        <div className="mb-3">
          <label className="form-label">Tune Name *</label>
          <input
            type="text"
            className="form-control"
            name="tune_name"
            value={formData.tune_name}
            onChange={handleChange}
            placeholder="e.g., OLD HUNDREDTH, AMAZING GRACE"
            required
          />
        </div>


        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="is_preferred"
            id="is_preferred"
            checked={formData.is_preferred || false}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="is_preferred">
            Preferred tune
          </label>
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button 
            type="submit"
            className="btn btn-primary"
            disabled={!formData.tune_name.trim()}
          >
            {initialTune?.tune_id ? 'Update' : 'Add'} Tune
          </button>
        </div>
      </form>
    </div>
  );
};